const UnloadRouteFlyModel = {
    id: "",
    created_at: null,
    name: "",
    description: "",
    email: "",
    zone: {
        id: "",
        name: "",
        polylines: [],
    },
    active: false,
    status: "",
    started_at: null,
    opened_at: null,
    completed_at: null,
};

export default UnloadRouteFlyModel;
